
















































































import Vue from "vue";

export interface Toast {
  type: ToastType;
  title: string;
  content: string;
}

export enum ToastType {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
  WARNING = "WARNING",
  INFO = "INFO"
}

export enum ToastPosition {
  TOP_LEFT = "TOPLEFT",
  TOP_RIGHT = "TOPRIGHT",
  BOTTOM_LEFT = "BOTTOMLEFT",
  BOTTOM_RIGHT = "BOTTOMRIGHT",
  CENTER = "CENTER"
}

export default Vue.extend({
  name: "Toast",
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Toast Title"
    },
    content: {
      type: String,
      default: "Toast Content"
    },
    BackgroundColor: {
      type: String,
      default: "var(--main-color)"
    },
    width: {
      type: Number,
      default: 350
    },
    BorderRadius: {
      type: String,
      default: "6px"
    },
    toastType: {
      type: String,
      default: ToastType.INFO
    },
    toastPosition: {
      type: String,
      default: ToastPosition.CENTER
    }
  },
  data: () => {
    return {
      toast_types: {
        ERROR: { icon: "mdi-alert-circle-outline", color: "#bc5265" },
        SUCCESS: { icon: "mdi-check", color: "#6caf8f" },
        WARNING: { icon: "mdi-alert", color: "#f59a2d" },
        INFO: { icon: "mdi-information-outline", color: "#17a9e1" }
      }
    };
  },
  computed: {
    style() {
      return {
        borderRadius: this.BorderRadius,
        backgroundColor: this.BackgroundColor
      };
    }
  }
});
